import React from 'react';
import './DropDownMenu.style.css';
import { DownOutlined } from '@ant-design/icons';

const DropDownMenu = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { items = [], value = '', layoutStyle = {}, onSelect, icon } = props;

  /* ===== State ===== */
  const [isShow, setIsShow] = React.useState(false);
  const [selectValue, setSelectValue] = React.useState(value);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleSelectValue = (item) => {
    if (onSelect) {
      onSelect(item);
    } else {
      setSelectValue(item.label);
    }
    setIsShow(!isShow);
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  React.useEffect(() => {
    const findLabel = items.find((item) => item.value === value) ?? '';

    setSelectValue(findLabel.label);
  }, [value]);

  /* ===== Render ===== */
  return (
    <div className="dn-drop-down-wrap" style={layoutStyle}>
      <div
        className="dn-drop-down-value-wrap"
        onClick={() => setIsShow(!isShow)}
      >
        <p>{selectValue}</p>
        {icon !== null ? (
          icon ? (
            icon
          ) : (
            <DownOutlined className="dn-drop-down-value-icon" />
          )
        ) : null}
      </div>
      {isShow ? (
        <ul className="dn-drop-down">
          {items.map((item, index) => (
            <li
              key={item.value ?? index}
              className={`dn-drop-down-items ${
                value === item.value ? 'active' : ''
              }`}
            >
              <button onClick={() => handleSelectValue(item)}>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default DropDownMenu;
